import React from 'react';
import TeacherChat from '@assets/icons/teacher-chat';
import { atom, useAtom } from 'jotai';
import {
  clickFloatingButtonAtom,
  resetDiscussQuestionAtom,
} from '@atom/worksheetAtom';
import { minichatOpenAtom } from './MinichatFloatingButtonWrapper';

export const isTeacherChatReadyAtom = atom(false);

type FloatingButtonProps = {
  bottomPosition?: string;
  ready?: boolean; // this added because we're going to send this component as a props to Genieask component on `trigger` props that should receive a boolean value
  unreadMessage?: string;
};

const unreadIndicator = () => {
  const currentUrl = window.location.href;
  if (!currentUrl) {
    return;
  }

  const rightStyle = currentUrl.includes('worksheets/completed')
    ? 'right-[-20px]'
    : 'right-[-140px]';

  return (
    <div
      className={`absolute ${rightStyle} top-[-25px] z-10 h-[14px] w-[14px] rounded-full border-2 border-black bg-[#E03636]`}
    ></div>
  );
};

const FloatingButton = ({
  ready = false,
  unreadMessage,
}: FloatingButtonProps) => {
  const [, setTeacherChatReady] = useAtom(isTeacherChatReadyAtom);
  const [minichatShown] = useAtom(minichatOpenAtom);

  React.useEffect(() => {
    setTeacherChatReady(ready);
  }, [ready]);

  const floatingBtnRef = React.useRef<HTMLDivElement>(null);
  const [clickFloatingButton, setClickFloatingButton] = useAtom(
    clickFloatingButtonAtom,
  );
  const [, setResetDiscussQuestionProps] = useAtom(resetDiscussQuestionAtom);

  // temporary until genieask minichat is ready
  React.useEffect(() => {
    if (floatingBtnRef.current && clickFloatingButton) {
      floatingBtnRef.current?.click();
    }
    // clean up function. making sure the state of clickFloatingButton is reset to its initial state which is false
    return () => {
      setClickFloatingButton(false);
    };
  }, [clickFloatingButton]);

  const handleClickTeacherButton = () => {
    setResetDiscussQuestionProps(true);
  };

  return (
    <div
      id="genieask_floating_icon"
      className={`mb-[30px] ${minichatShown ? 'invisible' : ''}`}
      ref={floatingBtnRef}
    >
      <div
        id="genieask_floating_button_component"
        className="relative flex flex-col items-center pb-[30px]"
      >
        {unreadMessage && unreadMessage != '0' && unreadIndicator()}

        <button
          className="bg-primary-apricot btn-icon-shadow absolute -left-[18px] bottom-1 flex h-12 max-w-[363px] cursor-pointer items-center justify-center overflow-hidden rounded-2xl px-[42px] text-center font-bold text-white"
          style={{ boxShadow: '0px 4px #E57B41' }}
          onClick={() => handleClickTeacherButton()}
          data-testid="floating-button"
        >
          <div className="button_bg_hover"></div>
          <div className="button_content flex-none">
            <TeacherChat
              width={16}
              height={16}
              className="fill-current text-neutral-chalk mt-[2px] mr-[2px]"
            />
            <span className="text-sm">Teacher Chat</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default FloatingButton;
